module.exports = __webpack_public_path__ + "static/media/hammadashraf.fc544a39.jpeg";